import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = {
  class: "flex align-items-center justify-content-between px-3 pb-5",
  style: {"flex-wrap":"wrap","gap":"1rem"}
}
const _hoisted_3 = {
  class: "flex gap-3",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_4 = { class: "s20 widget px-6 pt-8 pb-1" }
const _hoisted_5 = { class: "s10 mt--5-5 gap-4 flex-right" }
const _hoisted_6 = { class: "collectivite-header" }
const _hoisted_7 = { class: "collectivite-identity" }
const _hoisted_8 = { class: "collectivite-logo" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "collectivite-identity-body" }
const _hoisted_11 = {
  class: "flex align-items-center gap-3 mb-2",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_12 = { style: {"margin":"0"} }
const _hoisted_13 = { class: "text-grey-600 mb-4" }
const _hoisted_14 = { class: "collectivite-info-grid" }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "font-semibold text-truncate" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { class: "font-semibold" }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { class: "font-semibold" }
const _hoisted_27 = { class: "collectivite-stats" }
const _hoisted_28 = { class: "progress-bar-header mb-2" }
const _hoisted_29 = { class: "text-sm text-grey-500" }
const _hoisted_30 = { class: "progress-bar" }
const _hoisted_31 = { class: "progress-bar-header mb-2" }
const _hoisted_32 = {
  class: "font-semibold",
  style: {"margin":"0"}
}
const _hoisted_33 = { class: "text-sm text-grey-500" }
const _hoisted_34 = { class: "progress-bar" }
const _hoisted_35 = { class: "progress-bar-header mb-2" }
const _hoisted_36 = {
  class: "font-semibold",
  style: {"margin":"0"}
}
const _hoisted_37 = { class: "text-sm text-grey-500" }
const _hoisted_38 = { class: "progress-bar" }
const _hoisted_39 = { class: "s20 flex items-center px-8 pb-2 gap-6" }
const _hoisted_40 = { class: "s7" }
const _hoisted_41 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_42 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_43 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_44 = { class: "s7" }
const _hoisted_45 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_46 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_47 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_48 = { class: "s6" }
const _hoisted_49 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_50 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_51 = { class: "flex items-center gap-6" }
const _hoisted_52 = { class: "s7" }
const _hoisted_53 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_54 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_55 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_56 = { class: "s7" }
const _hoisted_57 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_58 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_59 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_60 = { class: "s6" }
const _hoisted_61 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_62 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_63 = { class: "px-5" }
const _hoisted_64 = {
  key: 0,
  style: {"display":"flex","align-items":"center","gap":"1.5rem"}
}
const _hoisted_65 = { style: {"width":"160px","height":"160px","min-width":"160px","max-width":"160px","flex":"0 0 160px","border-radius":"15px","overflow":"hidden"} }
const _hoisted_66 = ["src"]
const _hoisted_67 = { style: {"flex":"1 1 auto","min-width":"0"} }
const _hoisted_68 = { class: "mb-2" }
const _hoisted_69 = { class: "text-xl" }
const _hoisted_70 = { class: "text-xl" }
const _hoisted_71 = {
  key: 0,
  class: "text-xl mt-2"
}
const _hoisted_72 = {
  key: 1,
  class: "text-grey-500 text-center py-5"
}
const _hoisted_73 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_74 = { class: "table separator skin3 selection rounded" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "selection-item" }
const _hoisted_78 = ["for"]
const _hoisted_79 = ["id", "value"]
const _hoisted_80 = { class: "flex" }
const _hoisted_81 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_82 = ["src"]
const _hoisted_83 = {
  key: 0,
  class: "square-xl rounded-15 ml-3 px-3 py-3",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_84 = ["src"]
const _hoisted_85 = { style: {"width":"20%"} }
const _hoisted_86 = { class: "text-xl font-semibold mb-2" }
const _hoisted_87 = {
  key: 0,
  class: "tag-state warning stroke"
}
const _hoisted_88 = {
  key: 1,
  class: "tag-state notif stroke"
}
const _hoisted_89 = {
  key: 0,
  class: "tag-state success stroke ml-2"
}
const _hoisted_90 = { class: "text-3xl" }
const _hoisted_91 = { class: "mt-1" }
const _hoisted_92 = { class: "flex-right gap-4" }
const _hoisted_93 = ["onClick", "disabled"]
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","justify-content":"center"}
}

import { inject, ref, computed, onMounted, reactive } from 'vue';
    import { useRouter } from 'vue-router';
    import axios from 'axios';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import CustomPagination from '@/components/CustomPagination.vue';
    import { showAlert } from '@/utils/swal';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MaCollectivite',
  setup(__props) {

    const router = useRouter();
    const BACKEND_URL = inject('BACKEND_URL');
    const collectivite = ref<any>({});
    const membersList = ref<any[]>([]);
    const loadingMembers = ref(false);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const loadingSendInvitation = ref<{ [key: number]: boolean }>({});
    const activeTab = ref('information');
    const selectedMembers = ref<number[]>([]);

    const isCollectiviteOpen = ref(true);
    const isWalletOpen = ref(true);
    const isGerantSectionOpen = ref(true);
    const isMembresOpen = ref(true);

    const membersPagination = reactive({
        pageNumber: 1,
        total: 0,
        per_page: 10,
        last_page: 1
    });

    const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

    function formatDateFrench(dateString: string | null): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        return `${date.getDate()} ${monthsFr[date.getMonth()]} ${date.getFullYear()}`;
    }

    function formatAmountFr(amount: number | null | undefined): string {
        if (amount === null || amount === undefined) return '0 F';
        return new Intl.NumberFormat('fr-FR').format(amount) + ' F';
    }

    function calculatePercentage(value: number | null, total: number | null): number {
        if (!value || !total || total === 0) return 0;
        return Math.round((value / total) * 100 * 10) / 10;
    }

    async function fetchCollectiviteDetails() {
        try {
            const response = await axios.get('/collectivites/ma-collectivite/details');
            collectivite.value = response.data;
        } catch (error: any) {
            console.error('Erreur lors du chargement de la collectivité:', error);
        }
    }

    async function fetchMembers() {
        if (!collectivite.value.id) return;
        try {
            loadingMembers.value = true;
            const response = await axios.get('/collectivites/membres/list', {
                params: {
                    pageSize: membersPagination.per_page,
                    pageNumber: membersPagination.pageNumber,
                }
            });
            membersList.value = response.data.data || [];
            membersPagination.total = response.data.total || 0;
            membersPagination.last_page = response.data.last_page || 1;
        } catch (error: any) {
            console.error('Erreur lors du chargement des membres:', error);
        } finally {
            loadingMembers.value = false;
        }
    }

    onMounted(async () => {
        await fetchCollectiviteDetails();
        if (collectivite.value.id) {
            fetchMembers();
        }
    });

    function onMembersPaginate(pageNumber: number) {
        membersPagination.pageNumber = pageNumber;
        fetchMembers();
    }

    async function sendInvitationsUnverified(memberId: number) {
        const confirmation = await confirmationModalRef.value?.open(
            "Confirmer l'envoi des invitations",
            "Voulez-vous vraiment envoyer une invitation au membre sélectionné ?"
        );
        if (!confirmation) return;

        loadingSendInvitation.value[memberId] = true;
        try {
            await axios.post('/collectivites/membres/send_invitations_unverified', {
                users_ids: [memberId],
                collectivite_id: collectivite.value.id
            });
            showAlert.success('Invitation envoyée avec succès');
        } catch (error: any) {
            console.error("Erreur lors de l'envoi de l'invitation:", error);
            showAlert.error(error.response?.data?.message || "Une erreur est survenue lors de l'envoi de l'invitation");
        } finally {
            loadingSendInvitation.value[memberId] = false;
        }
    }

    function getGerantPhotoUrl(gerant: any): string {
        const fallback = '/public/assets/users/300w/user2.jpg';
        if (!gerant) return fallback;
        return gerant.photo_url || gerant.avatar_url || fallback;
    }

    function goToEdit() {
        router.push('/front/collectivites/ma-collectivite/edit');
    }

    const stats = computed(() => collectivite.value.stats || {});

    const secteursLabel = computed(() => {
        const s = collectivite.value.secteurs;
        if (Array.isArray(s)) return s.join(', ');
        return s || '';
    });

    const membersPercentage = computed(() => {
        const maxMembers = 50000;
        return Math.min(100, calculatePercentage(stats.value.members_count, maxMembers));
    });

    const prelevementPercentage = computed(() => {
        const current = stats.value.current_prelevement;
        if (!current) return 0;
        return calculatePercentage(current.montant_prelevement, current.montant_prelevement_expected);
    });

    const decaissementPercentage = computed(() => {
        const current = stats.value.current_decaissement;
        if (!current) return 0;
        return calculatePercentage(current.montant_decaissement, current.montant_decaissement_expected);
    });

    const activeBalancePercentage = computed(() =>
        calculatePercentage(stats.value.active_balance, stats.value.total_balance)
    );
    const blockedBalancePercentage = computed(() =>
        calculatePercentage(stats.value.blocked_balance, stats.value.total_balance)
    );

    const walletSolde = computed(() => {
        const totalPrelevements = stats.value.total_prelevements || 0;
        const totalDecaissements = stats.value.total_decaissements || 0;
        return totalPrelevements - totalDecaissements;
    });

    const walletSoldePercentage = computed(() => {
        const totalPrelevements = stats.value.total_prelevements || 0;
        if (totalPrelevements === 0) return 0;
        return calculatePercentage(walletSolde.value, totalPrelevements);
    });

    const decaissementTotalPercentage = computed(() => {
        const totalPrelevements = stats.value.total_prelevements || 0;
        if (totalPrelevements === 0) return 0;
        return calculatePercentage(stats.value.total_decaissements, totalPrelevements);
    });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("h4", {
        class: "font-semibold",
        style: {"margin":"0"}
      }, "Ma collectivité", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["btn shadow-200 white2", { active: activeTab.value === 'information' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'information'))
        }, "Information", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["btn shadow-200 white2", { active: activeTab.value === 'membres' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'membres'))
        }, "Membres", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["s10 mt--4 ml--4 mb-5 collapse-open", { active: isCollectiviteOpen.value }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (isCollectiviteOpen.value = !isCollectiviteOpen.value)),
        style: {"cursor":"pointer"}
      }, [...(_cache[9] || (_cache[9] = [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/public/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Collectivité ")
        ], -1)
      ]))], 2),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn lg py-3 white2 active",
          onClick: _withModifiers(goToEdit, ["stop"])
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("img", {
            src: "/public/icons/icon-edit.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Éditer", -1)
        ]))])
      ]),
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["collapse-content pt-5 pb-8", { active: isCollectiviteOpen.value }])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: collectivite.value.logo ? (_unref(BACKEND_URL) + '/assets/collectivites/' + collectivite.value.logo) : '/public/assets/logos/logo2.svg',
                alt: "logo"
              }, null, 8, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", _hoisted_12, _toDisplayString(collectivite.value.nom || ''), 1),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
              ]),
              _createElementVNode("p", _hoisted_13, _toDisplayString(collectivite.value.rccm || 'RCCM non renseigné'), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm text-grey-500 mb-1" }, "Pays / Secteurs", -1)),
                  _createElementVNode("p", _hoisted_15, [
                    _createTextVNode(_toDisplayString(collectivite.value.pays?.nom || 'Côte d\'Ivoire') + " ", 1),
                    (secteursLabel.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " · " + _toDisplayString(secteursLabel.value), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (collectivite.value.telephone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-sm text-grey-500 mb-1" }, "Téléphone", -1)),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(collectivite.value.telephone), 1)
                    ]))
                  : _createCommentVNode("", true),
                (collectivite.value.email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm text-grey-500 mb-1" }, "Email", -1)),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(collectivite.value.email), 1)
                    ]))
                  : _createCommentVNode("", true),
                (collectivite.value.adresse)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm text-grey-500 mb-1" }, "Adresse", -1)),
                      _createElementVNode("p", _hoisted_22, _toDisplayString(collectivite.value.adresse), 1)
                    ]))
                  : _createCommentVNode("", true),
                (collectivite.value.date_creation || collectivite.value.created_at)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-sm text-grey-500 mb-1" }, "Date de création", -1)),
                      _createElementVNode("p", _hoisted_24, _toDisplayString(formatDateFrench(collectivite.value.date_creation || collectivite.value.created_at)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (collectivite.value.date_souscription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-sm text-grey-500 mb-1" }, "Date de souscription", -1)),
                      _createElementVNode("p", _hoisted_26, _toDisplayString(formatDateFrench(collectivite.value.date_souscription)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_28, [
                _cache[18] || (_cache[18] = _createElementVNode("h6", {
                  class: "font-semibold",
                  style: {"margin":"0"}
                }, "Membres", -1)),
                _createElementVNode("span", _hoisted_29, _toDisplayString(stats.value.members_count || 0) + " / 50 000", 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", {
                  class: "progress-bar-fill bg-pop-green",
                  style: _normalizeStyle({ width: Math.max(membersPercentage.value, 2) + '%' })
                }, _toDisplayString(membersPercentage.value) + "% ", 5)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("h6", _hoisted_32, "Prélèvement " + _toDisplayString(stats.value.current_month_label || ''), 1),
                _createElementVNode("span", _hoisted_33, _toDisplayString(formatAmountFr(stats.value.current_prelevement?.montant_prelevement)) + " / " + _toDisplayString(formatAmountFr(stats.value.current_prelevement?.montant_prelevement_expected || 0)), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", {
                  class: "progress-bar-fill bg-pop-green",
                  style: _normalizeStyle({ width: Math.max(prelevementPercentage.value, 2) + '%' })
                }, _toDisplayString(prelevementPercentage.value) + "% ", 5)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h6", _hoisted_36, "Décaissement " + _toDisplayString(stats.value.current_month_label || ''), 1),
                _createElementVNode("span", _hoisted_37, _toDisplayString(formatAmountFr(stats.value.current_decaissement?.montant_decaissement)) + " / " + _toDisplayString(formatAmountFr(stats.value.current_decaissement?.montant_decaissement_expected || 0)), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", {
                  class: "progress-bar-fill bg-color-1000 text-white",
                  style: _normalizeStyle({ width: Math.max(decaissementPercentage.value, 2) + '%' })
                }, _toDisplayString(decaissementPercentage.value) + "% ", 5)
              ])
            ])
          ])
        ]),
        _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "my-7" }, null, -1)),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[19] || (_cache[19] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
              _createTextVNode(" Débloqué ")
            ], -1)),
            _createElementVNode("h1", _hoisted_41, _toDisplayString(formatAmountFr(stats.value.active_balance)), 1),
            _createElementVNode("h5", _hoisted_42, _toDisplayString(activeBalancePercentage.value) + "%", 1),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                style: _normalizeStyle({ width: Math.max(activeBalancePercentage.value, 5) + '%' })
              }, _toDisplayString(activeBalancePercentage.value) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[20] || (_cache[20] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-purple" }),
              _createTextVNode(" Bloqué ")
            ], -1)),
            _createElementVNode("h1", _hoisted_45, _toDisplayString(formatAmountFr(stats.value.blocked_balance)), 1),
            _createElementVNode("h5", _hoisted_46, _toDisplayString(blockedBalancePercentage.value) + "%", 1),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white",
                style: _normalizeStyle({ width: Math.max(blockedBalancePercentage.value, 5) + '%' })
              }, _toDisplayString(blockedBalancePercentage.value) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _cache[21] || (_cache[21] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-green-light" }),
              _createTextVNode(" Total ")
            ], -1)),
            _createElementVNode("h1", _hoisted_49, _toDisplayString(formatAmountFr(stats.value.total_balance)), 1),
            _cache[22] || (_cache[22] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
            _cache[23] || (_cache[23] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                style: {"width":"100%"}
              }, " 100% ")
            ], -1))
          ])
        ])
      ], 2), [
        [_vShow, isCollectiviteOpen.value]
      ])
    ]),
    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", {
        class: _normalizeClass(["s10 mt--4 ml--4 mb-5 collapse-open", { active: isWalletOpen.value }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (isWalletOpen.value = !isWalletOpen.value)),
        style: {"cursor":"pointer"}
      }, [...(_cache[26] || (_cache[26] = [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/public/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Wallet / Décaissement ")
        ], -1)
      ]))], 2),
      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["s20 gap-6 px-5 pb-8 collapse-content", { active: isWalletOpen.value }])
      }, [
        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _cache[27] || (_cache[27] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-black" }),
              _createTextVNode(" Solde ")
            ], -1)),
            _createElementVNode("h1", _hoisted_53, _toDisplayString(formatAmountFr(walletSolde.value)), 1),
            _createElementVNode("h5", _hoisted_54, _toDisplayString(walletSoldePercentage.value) + "%", 1),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-black",
                style: _normalizeStyle({ width: Math.max(walletSoldePercentage.value, 5) + '%' })
              }, _toDisplayString(walletSoldePercentage.value) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _cache[28] || (_cache[28] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
              _createTextVNode(" Montant Décaissé ")
            ], -1)),
            _createElementVNode("h1", _hoisted_57, _toDisplayString(formatAmountFr(stats.value.total_decaissements)), 1),
            _createElementVNode("h5", _hoisted_58, _toDisplayString(decaissementTotalPercentage.value) + "%", 1),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                style: _normalizeStyle({ width: Math.max(decaissementTotalPercentage.value, 5) + '%' })
              }, _toDisplayString(decaissementTotalPercentage.value) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _cache[29] || (_cache[29] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-green-light" }),
              _createTextVNode(" Dernier décaissement ")
            ], -1)),
            _createElementVNode("h1", _hoisted_61, _toDisplayString(formatAmountFr(stats.value.last_decaissement?.montant_decaissement)), 1),
            _cache[30] || (_cache[30] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
            _cache[31] || (_cache[31] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                style: {"width":"100%"}
              }, " 100% ")
            ], -1))
          ])
        ])
      ], 2), [
        [_vShow, isWalletOpen.value]
      ])
    ]),
    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", {
        class: _normalizeClass(["s10 mt--4 ml--4 mb-5 collapse-open", { active: isGerantSectionOpen.value }]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (isGerantSectionOpen.value = !isGerantSectionOpen.value)),
        style: {"cursor":"pointer"}
      }, [...(_cache[34] || (_cache[34] = [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/public/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Gérant ")
        ], -1)
      ]))], 2),
      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["s20 collapse-content pt-3 pb-6", { active: isGerantSectionOpen.value }])
      }, [
        _createElementVNode("div", _hoisted_63, [
          (collectivite.value.current_gerant)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("img", {
                    src: getGerantPhotoUrl(collectivite.value.current_gerant),
                    style: {"width":"160px","height":"160px","object-fit":"cover","display":"block"}
                  }, null, 8, _hoisted_66)
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("h3", _hoisted_68, _toDisplayString(collectivite.value.current_gerant.nom) + " " + _toDisplayString(collectivite.value.current_gerant.prenom), 1),
                  _createElementVNode("p", _hoisted_69, _toDisplayString(collectivite.value.current_gerant.email), 1),
                  _createElementVNode("p", _hoisted_70, _toDisplayString(collectivite.value.current_gerant.telephone), 1),
                  (collectivite.value.current_gerant.fonction)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_71, _toDisplayString(collectivite.value.current_gerant.fonction), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_72, " Aucun gérant désigné pour cette collectivité. "))
        ])
      ], 2), [
        [_vShow, isGerantSectionOpen.value]
      ])
    ]),
    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_73, [
      _createElementVNode("div", {
        class: _normalizeClass(["s10 mt--4 ml--4 mb-5 collapse-open", { active: isMembresOpen.value }]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (isMembresOpen.value = !isMembresOpen.value)),
        style: {"cursor":"pointer"}
      }, [...(_cache[36] || (_cache[36] = [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/public/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Membres ")
        ], -1)
      ]))], 2),
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["s20 items-center gap-6 px-0 pb-6 collapse-content", { active: isMembresOpen.value }])
      }, [
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
        _createElementVNode("table", _hoisted_74, [
          _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", {
                  class: "btn-circle",
                  for: "check-members-all"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    name: "check-members-all",
                    id: "check-members-all"
                  })
                ])
              ]),
              _createElementVNode("th"),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Information")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Utilisation")
              ]),
              _createElementVNode("th", { class: "flex-right" }, [
                _createElementVNode("button", { class: "btn-ultra color2" }, [
                  _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-actif.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Actif")
                  ]),
                  _createElementVNode("div", { class: "btn-loading" }, [
                    _createElementVNode("div", { class: "loader-dots" })
                  ])
                ])
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (loadingMembers.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_75, [...(_cache[37] || (_cache[37] = [
                  _createElementVNode("td", {
                    colspan: "5",
                    class: "text-center text-grey-500 py-5"
                  }, [
                    _createElementVNode("div", { class: "loader dark" })
                  ], -1)
                ]))]))
              : (membersList.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [...(_cache[38] || (_cache[38] = [
                    _createElementVNode("td", {
                      colspan: "5",
                      class: "text-center text-grey-500 py-5"
                    }, " Aucun membre trouvé ", -1)
                  ]))]))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(membersList.value, (member, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "text-grey-700 over-effect",
                key: 'member_' + index
              }, [
                _createElementVNode("td", _hoisted_77, [
                  _createElementVNode("label", {
                    class: "btn-circle",
                    for: 'member_check_' + index
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      name: "selectedMembers[]",
                      id: 'member_check_' + index,
                      value: member.id,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedMembers).value = $event))
                    }, null, 8, _hoisted_79), [
                      [_vModelCheckbox, selectedMembers.value]
                    ])
                  ], 8, _hoisted_78)
                ]),
                _createElementVNode("td", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("img", {
                      src: member.photo_url || member.avatar_url || '/public/assets/users/300w/user2.jpg',
                      width: "100%"
                    }, null, 8, _hoisted_82)
                  ]),
                  (collectivite.value.logo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        _createElementVNode("img", {
                          src: _unref(BACKEND_URL) + '/assets/collectivites/' + collectivite.value.logo,
                          width: "100%"
                        }, null, 8, _hoisted_84)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_85, [
                  _createElementVNode("p", _hoisted_86, [
                    _createTextVNode(_toDisplayString(member.reference || 'N/A') + "   ", 1),
                    (!member.email_verified_at)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_87, "En cours"))
                      : _createCommentVNode("", true),
                    (member.actif)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_88, "Actif"))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(member.nom + ' ' + member.prenom) + " - " + _toDisplayString(member.collectivite?.nom || collectivite.value.nom) + " ", 1),
                  (member.is_gerant)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_89, "Gérant"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_90, [
                  _createTextVNode(_toDisplayString(member.quotite_cessible_pourcent ? member.quotite_cessible_pourcent + '%' : '-') + " ", 1),
                  _createElementVNode("p", _hoisted_91, _toDisplayString(member.quotite_cessible_montant ? formatAmountFr(member.quotite_cessible_montant) : '-'), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_92, [
                    _createVNode(_component_router_link, {
                      to: '/front/collectivites/membres/' + member.id + '/edit'
                    }, {
                      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                        _createElementVNode("button", { class: "btn tips" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-edit.svg",
                            class: "btn-icon",
                            alt: ""
                          })
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    (member.can_receive_invitation_link == true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: ($event: any) => (sendInvitationsUnverified(member.id)),
                          class: "btn normal ml-3 justify-content-center btn-filtre",
                          disabled: loadingSendInvitation.value[member.id]
                        }, [
                          _cache[40] || (_cache[40] = _createElementVNode("img", {
                            src: "/public/icons/icon-send.svg",
                            class: "btn-icon",
                            alt: ""
                          }, null, -1)),
                          (!loadingSendInvitation.value[member.id])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_94, "Envoyer invitation"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_95, "Envoi..."))
                        ], 8, _hoisted_93))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: '/front/collectivites/membres/' + member.id
                    }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Gérer")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/front/collectivites/membres/' + member.id + '/carte'
                    }, {
                      default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Carte")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        (membersList.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
              _createVNode(CustomPagination, {
                modelValue: membersPagination.pageNumber,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((membersPagination.pageNumber) = $event)),
                  onMembersPaginate
                ],
                total: membersPagination.total,
                "per-page": membersPagination.per_page,
                last_page: membersPagination.last_page
              }, null, 8, ["modelValue", "total", "per-page", "last_page"])
            ]))
          : _createCommentVNode("", true)
      ], 2), [
        [_vShow, isMembresOpen.value]
      ])
    ]),
    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "clear-both h-50" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ]))
}
}

})